import { useAuth, handleLogout } from "context/auth";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Header() {
  const [auth, dispatchAuth] = useAuth();
  const [username, setUsername] = useState(null);

  useEffect(() => {
    const tempUsername = localStorage.getItem("username");
    setUsername(tempUsername);
  }, []);

  return (
    <header className="header">
      <div
        className="app_container"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div className="logo">
          <img
            src={`${process.env.PUBLIC_URL}/ydeLogo.png`}
            alt="YDE"
            style={{ height: "60px" }}
          />
        </div>
        <h1
          style={{ marginLeft: "4rem", marginBottom: "0", fontWeight: "600" }}
        >
          Yellow Door Energy Map Viewer
        </h1>
        <ul className="links list-unstyled user-info">
          {!auth.isLoggedIn && (
            <li>
              <Link to="/auth" className="login-btn">
                تسجيل الدخول
              </Link>
            </li>
          )}
          {auth.isLoggedIn && (
            <li>
              <Dropdown>
                <Dropdown.Toggle
                  className="dropdown-basic-user-info"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#023A6C",
                    color: "#EBF0F5",
                    fontSize: "18px",
                  }}
                >
                  {/* <span>Hello .. </span> */}
                  <img
                    alt="user"
                    src={`${process.env.PUBLIC_URL}/imgs/UserProfile.png`}
                    style={{ height: "40px" }}
                  />
                  <span
                    // className="truncate"
                    style={{ display: "inline-block", marginInline: "15px" }}
                  >
                    {username || "User"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleLogout(dispatchAuth)}>
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          )}
        </ul>
      </div>
    </header>
  );
}
